export default __webpack_public_path__ + "static/media/clock.d8922eba.svg";